module.exports = __webpack_public_path__ + "img/314.669a85c1.jpg";